import { Button, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import SendIcon from "@mui/icons-material/Send";
import React, { useState } from "react";
import boxStyles from "../../../styles/boxStyles";
import DeleteIcon from "@mui/icons-material/Delete";
import fieldStyles from "../../../styles/fieldStyles";
import { LoadingButton } from "@mui/lab";
import ApiService from "../../../services/ApiService";
import SimpleMDE from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";

const KemungkinanPenyebab = ({
  inputFields,
  setInputFields,
  readOnly,
  setSnackbar,
}) => {
  const handleInputFile = async (e) => {
    // Set Loading
    setUploadDoc(true);

    // Baca File
    const files = e.target.files[0];
    console.log("files", files);

    // Init
    var formData = new FormData();

    formData.append("file", files);

    try {
      // Mengirimkan file (formData)
      await ApiService.postUploadDocument("LKP", formData)
        .then((res) => {
          if (res.data.isOk === false) {
            throw res.data.message;
          }
          const newUpload = res.data.payload;
          console.log("newUpload", newUpload);

          // Memasang respond
          setInputFields({
            ...inputFields,
            uploadDocumentList: [
              ...inputFields.uploadDocumentList,
              newUpload[0],
            ],
          });
          // setMedia((old) => {
          //   return [...old, newUpload[0]];
          // });
        })
        .catch((message) => {
          console.log(message);
          setSnackbar({
            isOpen: true,
            type: "warning",
            message,
          });
        });
    } catch (error) {
      setSnackbar({
        isOpen: true,
        type: "warning",
        error,
      });
    }

    setUploadDoc(false);
  };

  const handleRemoveFile = (id) => {
    // let temp = inputFields.uploadDocumentList.splice(idx, 1);
    // console.log("temp", temp);

    setInputFields({
      ...inputFields,
      uploadDocumentList: inputFields.uploadDocumentList.filter(
        (item) => item.id !== id
      ),
    });

    // setMedia((oldData) => {
    //   return oldData.splice(idx, 1);
    // });
  };

  // Loading Button
  const [uploadDoc, setUploadDoc] = useState(false);

  return (
    <div>
      <Box component="div" sx={boxStyles}>
        <center>
          <h3>KEMUNGKINAN PENYEBAB</h3>
        </center>

        <left>
          <h4>Penyebab Langsung</h4>
        </left>
        <Stack spacing={2}>
          <SimpleMDE
            value={inputFields.kemungkinanPenyebabLangsung}
            // options={{
            //   spellChecker: false,
            //   hideIcons: [
            //     "link",
            //     "image",
            //     "preview",
            //     "fullscreen",
            //     "guide",
            //     "side-by-side",
            //   ],
            // }}
            onChange={(value) => {
              setInputFields({
                ...inputFields,
                kemungkinanPenyebabLangsung: value,
              });
            }}
          />
          {/* <TextField
            name="kemungkinanPenyebabLangsung"
            label="Kemungkinan Penyebab Langsung"
            variant="outlined"
            fullWidth
            value={inputFields.kemungkinanPenyebabLangsung}
            onChange={(e) =>
              setInputFields({
                ...inputFields,
                kemungkinanPenyebabLangsung: e.target.value,
              })
            }
            disabled={readOnly}
          /> */}

          <left>
            <h4>Penyebab Dasar</h4>
          </left>
          <SimpleMDE
            value={inputFields.kemungkinanPenyebabDasar}
            // options={{
            //   spellChecker: false,
            //   hideIcons: [
            //     "link",
            //     "image",
            //     "preview",
            //     "fullscreen",
            //     "guide",
            //     "side-by-side",
            //   ],
            // }}
            onChange={(value) => {
              setInputFields({
                ...inputFields,
                kemungkinanPenyebabDasar: value,
              });
            }}
          />
          {/* <TextField
            name="kemungkinanPenyebabDasar"
            label="Kemungkinan Penyebab Dasar"
            variant="outlined"
            fullWidth
            value={inputFields.kemungkinanPenyebabDasar}
            onChange={(e) =>
              setInputFields({
                ...inputFields,
                kemungkinanPenyebabDasar: e.target.value,
              })
            }
            disabled={readOnly}
          /> */}

          <left>
            <h4>Immediate Action Yang Sudah Dilakukan</h4>
          </left>
          <SimpleMDE
            value={inputFields.immadiateAction}
            // options={{
            //   spellChecker: false,
            //   hideIcons: [
            //     "link",
            //     "image",
            //     "preview",
            //     "fullscreen",
            //     "guide",
            //     "side-by-side",
            //   ],
            // }}
            onChange={(value) => {
              setInputFields({
                ...inputFields,
                immadiateAction: value,
              });
            }}
          />
          {/* <TextField
            name="immadiateAction"
            label="Immediate Action Yang Sudah Dilakukan"
            variant="outlined"
            fullWidth
            value={inputFields.immadiateAction}
            onChange={(e) =>
              setInputFields({
                ...inputFields,
                immadiateAction: e.target.value,
              })
            }
            disabled={readOnly}
          /> */}

          <Box component="div" sx={fieldStyles}>
            <LoadingButton
              variant="contained"
              component="label"
              loading={uploadDoc}
              startIcon={<SendIcon />}
              loadingPosition="start"
              disabled={readOnly}
            >
              Upload Document
              <input
                hidden
                multiple
                accept=".pdf,.jpg"
                type="file"
                onChange={handleInputFile}
              />
            </LoadingButton>
            <span style={{ color: "red", marginLeft: "20px" }}>
              <small>
                * Format file upload yang diterima (.pdf, .jpg) (Maximum 10 Mb)
                {/* * Upload file (PDF, Word, Excel, PPT, Photo file) (Maximum 10
                Mb) */}
              </small>
            </span>
            <br />
            <br />

            {inputFields.uploadDocumentList.map((doc, idx) => (
              // {media.map((doc, idx) => (
              <div>
                <Tooltip title={doc.url} palcement="top">
                  <span style={{ opacity: "0.8" }}>
                    {idx + 1}.{" "}
                    <a href="#" target="_blank" rel="noopener noreferrer"  onClick={async (e) =>
                        await ApiService.viewFile(doc.url, e)
                    }>
                      {doc.fileName}
                    </a>
                  </span>
                </Tooltip>

                <IconButton
                  aria-label="delete"
                  color="error"
                  onClick={() => handleRemoveFile(doc.id)}
                  disabled={readOnly}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            ))}
          </Box>
        </Stack>
      </Box>
    </div>
  );
};

export default KemungkinanPenyebab;
